import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
//import KioskStylesReact from "./../../../KioskStylesReact";
import KioskStylesReact from "./../../../../KioskStylesReact";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import CircleButton from "./../../Components/Buttons/CircleButton";
import Logo from "./../../Components/Logo";
import LanguageButtons from "./../../Components/Shared/LanguageButtons";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

import KioskIDButton from "./../Shared/KioskIDButton";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import SplashImage from "./../../Components/LanguageSelect/SplashImage";
import PartnerLogo from "./../../Components/LanguageSelect/PartnerLogo";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal";

let env = require("./../../../../env");

export default function HorizontalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    errorMessage,
    isNotMobile,
    kioskkey
  } = props;

  const {
    isConnected,
    socketEvents,
    qrCode,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);

  const theme = useTheme();

  const kioskTheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();
  const kioskhorizontalstyles = KioskStylesReact();

  let showPartnerLogo = kioskTheme.showPartnerLogo;

  if (showPartnerLogo == true) {
    showPartnerLogo = "true";
  }

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={kioskstyles.GridFullHeightFix}
    >
      <FlexLeftPanel isNotMobile={isNotMobile}>
        <div
          class="ks_flexLeftPanelContents"
          style={kioskstyles.flexLeftPanelContents}
        >
          <div class="ks_flexParentPanel" style={kioskstyles.flexParentPanel}>
            {/* <div
              class="ks_flexPanelLayoutB_TopContainer"
              //style={kioskstyles.flexPanelLayoutB_TopContainer}
              style={kioskstyles.flexPanelLayoutC_TopContainer}
            >
              <Logo />
              <KioskIDButton />
            </div> */}
            {/* <div
              class="ks_flexPanelLayoutB_MidContainer_M"
              onClick={nextFunc}
              style={{
                ...kioskstyles.flexPanelLayoutB_MidContainer
              }}
            >
              <div class="fontBold" style={kioskstyles.languageselect.title}>
                <Translate value="application.theme.languageSelectMainText" />
              </div>
              <br />
              <Button
                variant="outlined"
                style={kioskstyles.languageselect.button}
              >
                <Translate value="application.theme.languageSelectContinueButton" />
              </Button>
            </div>
            <div
              style={{
                ...kioskstyles.flexPanelLayoutB_BotContainer,
                //position: "fixed",
                bottom: "10.5vh"
              }}
            >
              <div style={{ height: "10vh", width: "10vh" }}>
                <PartnerLogo />
              </div>
              <LanguageButtons />
            </div> */}
            <div
              class="ks_flexPanelLayoutA_TopContainer"
              //style={kioskstyles.flexPanelLayoutB_TopContainer}

              style={kioskstyles.flexPanelLayoutA_FillContainer}
            >
              <Logo />
              <KioskIDButton />

              <div
                class="fontBold"
                style={kioskstyles.languageselect.title}
                onClick={nextFunc}
              >
                <Translate value="application.theme.languageSelectMainText" />
              </div>
              <Button
                variant="outlined"
                style={kioskstyles.languageselect.button}
                onClick={nextFunc}
              >
                <Translate value="application.theme.languageSelectContinueButton" />
              </Button>

              <LanguageButtons />
              {showPartnerLogo == "true" && (
                <div
                  onClick={nextFunc}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      height: "12.5vh",
                      width: "11vh"
                    }}
                  >
                    <PartnerLogo />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </FlexLeftPanel>

      <Grid
        item
        xs={12}
        sm={6}
        style={kioskhorizontalstyles.flexRightSplashPanel}
        onClick={nextFunc}
      >
        <div style={kioskstyles.flexRightPanelContents}>
          <div
            style={{
              ...kioskstyles.flexParentPanel,
              marginTop: "0px",
              marginBottom: "0px"
            }}
          >
            <div
              style={{
                ...kioskstyles.flexPanelLayoutD,
                height: "100%"
              }}
            >
              {/* <SubtitleWrapper isNotMobile={isNotMobile}></SubtitleWrapper> */}
              {/* <div style={{ height: "calc(100% - clamp(0px, 3.2vi, 48px))" }}> */}
              <div
                style={{
                  display: "flex",
                  height: "100%",
                  alignContent: "center",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  width: "100%"
                }}
              >
                <SplashImage
                  trigger={translate("application.languageselect.presstostart")}
                />
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </Grid>
      <PrinterConnectionModal />
    </Grid>
  );
}
